import { useEffect, useState } from 'react'
import { consumirApi } from '../../../utils/consumoApi'
import { agregarDatosEmpresaUsuario } from '../../../utils/empresaUsuario'
import ErrorAlert from '../../../components/common/ErrorAlert'
import Table from '../../../components/tables/TableFilter'
import Button from '../../../components/common/Button'
import Modal from '../../../components/modals/Modal'
import ModalConfirmacion from '../../../components/modals/ModalConfirmacion'
import Form from '../../../components/forms/Form'
import Input from '../../../components/common/Input'
import Notification from '../../../components/common/Notification'
import Spinner from '../../../components/common/Spinner'

const Especialidad = () => {
    const [datos, setDatos] = useState([])
    // campos 
    const [idEspecialidad, setIdEspecialidad] = useState("")
    const [especialidad, setEspecialidad] = useState("")
    // modales 
    const [mostrarModal, setMostrarModal] = useState(false)
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false)
    const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false)
    // notificaciones y cargas 
    const [cargando, setCargando] = useState(true)
    const [error, setError] = useState("")
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [isSubmitting, setIsSubmitting] = useState(false)
    //seleccion de fila
    const [selectedId, setSelectedId] = useState(null)
    //datos para la tabla
    const columnas = [
        { titulo: 'Especialidad', campo: 'especialidad' },
    ]

    // Carga inicial de los tipos de terreno
    useEffect(() => { obtenerEspecialidades() }, [])

    // Función para traer los tipos de terreno
    const obtenerEspecialidades = async () => {
        const respuesta = await consumirApi('GET', `maestros/especialidad`)
        setDatos(respuesta.success ? respuesta.data : respuesta.error)
        setCargando(false)
    }

    //Funcion para registrar nuevo tipo de terreno
    const registrarEspecialidad = (async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        agregarDatosEmpresaUsuario(formData)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', `maestros/especialidad`, formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "Especialidad registrado correctamente" })
            limpiarCampos()
            obtenerEspecialidades()
        }
        else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    })

    // funcion para abrir el modal para editar tipo de terreno 
    const abrirModalEditar =(data) => {
        setIdEspecialidad(data.id)
        setEspecialidad(data.especialidad)
        setMostrarModalEditar(true)
    }

    // Edición de tipo de terreno
    const enviarEdicionEspecialidad = async (e) => {
        e.preventDefault()
        const data = { especialidad }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/especialidad/${idEspecialidad}`, data)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Especialidad actualizado correctamente" })
            limpiarCampos()
            obtenerEspecialidades()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Manejar selección de checkbox
    const seleccionEspecialidad = (data) => {
        setSelectedId((prevSelectedId) => (prevSelectedId === data.id ? null : data.id))
    }

    // funcion para abrir el modal para editar Especialidad
    const eliminarEspecialidad = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/especialidad/${selectedId}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Especialidad eliminada correctamente" })
            limpiarCampos()
            obtenerEspecialidades()
        } else {
            setError(respuesta.error)
        }
    }

    const limpiarCampos = () => {
        setError('')
        setSelectedId(null)
        setEspecialidad('')
        setMostrarModal(false)
        setMostrarModalEditar(false)
        setMostrarModalEliminar(false)
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    return (
        <div className='w-full min-h-[calc(100vh-50px)]'>
            <Button className="ml-5 mt-2" texto='+ Nuevo' onClick={() => setMostrarModal(true)} />
            <Button className="ml-3 mt-2"  type="delete" disabled={!selectedId} onClick={()=>setMostrarModalEliminar(true)} />
            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : (
                datos.length === 0 ? (
                    <div className="ml-5">No se encontraron Especialidades</div>
                ) : (
                    <Table datos={datos} listaCampos={columnas} editarRegistro={abrirModalEditar}
                        mostrarChecks={true}
                        seleccionFila={seleccionEspecialidad} // Manejar el ID seleccionado
                        selectedId={selectedId} // Manejar el ID seleccionado
                    />
                )
            )}

            {/* Modal Registrar nuevo Especialidad*/}
            <Modal isOpen={mostrarModal} title="Registrar nueva especialidad" onClose={limpiarCampos} >
                <Form onSubmit={registrarEspecialidad} isSubmitting={isSubmitting}>
                    <Input name="especialidad" value={especialidad} label="Especialidad" onChange={setEspecialidad} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal Actuazliar nuevo Especialidad*/}
            <Modal isOpen={mostrarModalEditar} title="Actualizar especialidad" onClose={limpiarCampos} >
                <Form onSubmit={enviarEdicionEspecialidad}  isSubmitting={isSubmitting} type='update'>
                    <Input name="especialidad" value={especialidad} label="Especialidad" onChange={setEspecialidad} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal de confirmación para eliminar un tipo de terreno*/}
            <ModalConfirmacion
                isOpen={mostrarModalEliminar}
                onClose={limpiarCampos}
                onConfirm={eliminarEspecialidad}
                mensaje="¿Estás seguro de que deseas eliminar la especialidad?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>

        </div>
    )
}

export default Especialidad
